import { Grid, IconButton, Popover, Tooltip } from '@material-ui/core';
import { WatchLater } from '@material-ui/icons';
import { useState } from 'react';
import create, { UseStore } from 'zustand';
import { FieldValue, FieldValueProductivity } from '../components/common/presentation';
import { fetchRequest } from './';
import {
  ProductivityEntry,
  productivityList,
  ProductivityLocation,
  ProductivityMap
} from './domain';
import { currentWorkflow } from './workflow-api';
import { worksheetMessage, WorksheetResult } from './worksheet-service';

const service = 'productivity';

export type ProductivityResult = WorksheetResult<ProductivityMap>;

const productivityMapRequest = fetchRequest<void, ProductivityResult>({
  method: 'post',
  body: () =>
    worksheetMessage(null, 'getcoderproductivity', service, currentWorkflow()),
});

export async function productivityRequest(): Promise<ProductivityEntry[]> {
  const response = await productivityMapRequest();
  if (response?.errors) {
    throw response.errors.join(',');
  }
  return productivityList(response.result);
}

type ProductivityApi = {
  total: number;
  list: ProductivityEntry[];
  open: boolean;
  update: () => void;
};

function productivityApi(): UseStore<ProductivityApi> {
  return create<ProductivityApi>((set) => ({
    total: 0,
    list: [],
    open: false,
    update: async () => {
      const list = (await productivityRequest()) || [];
      //  console.log('ProductivityApi', list)
      let total = 0;
      list.forEach((v) => {
        v.locations.forEach((u) => {
          u.states.forEach((s) => (total += s.count));
        });
      });
      set({ total, list });
    },
  }));
}

export const coderProductivity = productivityApi();

function Location(props: ProductivityLocation) {
  const { location, states } = props;
  return (
    <Grid item style={{ paddingLeft: 12, width: '100%', flexWrap: 'nowrap' }}>
      {location}
      <Grid
        item
        container
        direction="column"
        style={{ paddingLeft: 12, width: '100%', flexWrap: 'nowrap', display: 'flex' }}
      >
        {states.map((v, i) => (
          <FieldValueProductivity
            row={true}
            wrap={false}
            containerStyle={{ width: '100%', display: 'flex'}}
            labelStyle={{ flexWrap: 'wrap', flex: 3 }}
            valueStyle={{ textAlign: 'right', flex: 1 }}
            key={i}
            label={v.label}
            value={v.count}
          />
        ))}
      </Grid>
    </Grid>
  );
}

function Department(props: ProductivityEntry) {
  const { department, locations } = props;
  return (
    <Grid
      item
      container
      direction="column"
      style={{ width: '100%', paddingRight: 0 }}
    >
      <Grid item> {department}</Grid>
      {locations.map((v, i) => (
        <Location key={i + 'l'} {...v} />
      ))}
    </Grid>
  );
}

export default function CoderProductivity() {
  const [anchorEl, setAnchorEl] = useState(null);

  const onOpen = (event: any) => {
    setAnchorEl(event.currentTarget);
    coderProductivity.getState().update();
    coderProductivity.setState({ open: true });
  };

  const onClose = () => {
    setAnchorEl(null);
    coderProductivity.setState({ open: false });
  };

  const list = coderProductivity((s) => s.list);
  const total = coderProductivity((s) => s.total);
  const open = coderProductivity((s) => s.open);

  return (
    <div>
      <Tooltip title="Coding Productivity">
        <IconButton id="open-coding-productivity-btn" onClick={onOpen} onMouseEnter={onOpen}>
          <WatchLater />
        </IconButton>
      </Tooltip>
      {
        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={onClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
        >
          <div id="coding-productivity" style={{ padding: 12, maxHeight: 400 }}>
            <Grid
              container
              direction="column"
              spacing={2}
              style={{ width: 230 }}
            >
              <Grid item>Coding Productivity:</Grid>
              {list.map((d, i) => (
                <Department key={i} {...d} />
              ))}
              <Grid item container direction="row" style={{ paddingRight: 18 }}>
                <Grid item style={{ flexGrow: 1 }} />
                <Grid item>Total: {total}</Grid>
              </Grid>
            </Grid>
          </div>
        </Popover>
      }
    </div>
  );
}
